import React, { createContext, useEffect, useState } from "react";
import api from "../admin/api/api";

export const ShopContext = createContext();

export const ShopProvider = ({ children }) => {

  const [shop, setShop] = useState(null);

  const loadShop = async () => {
    try {
      const res = await api.get("/settings/shop");
      setShop(res.data);
    } catch (error) {
      console.error("Shop load error", error);
    }
  };

  useEffect(() => {
    loadShop();
  }, []);

  return (
    <ShopContext.Provider value={{ shop }}>
      {children}
    </ShopContext.Provider>
  );
};